"use client";

import Link from "next/link";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/app/components/shadcn/accordion";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface FooterLinkItem {
  label: string;
  href: string;
}

interface FooterLinksProps {
  title: string;
  titleHref?: string;
  links: FooterLinkItem[];
}

const FooterLinks = ({ title, titleHref, links }: FooterLinksProps) => {
  return (
    <>
      {/* Mobile: accordion */}
      <div className="lg:hidden">
        <Accordion type="single" collapsible>
          <AccordionItem value={title} className="border-b-0">
            <AccordionTrigger className="text-sm font-medium py-2 hover:no-underline hover:text-main">
              {title}
            </AccordionTrigger>
            <AccordionContent className="pb-2">
              <div className="flex flex-col space-y-1.5">
                {links.map((link) => (
                  <Link
                    key={link.label}
                    href={link.href}
                    onClick={() => trackGeneric(`footer_link_${link.href.replace(/\//g, "").slice(0, 30)}`)}
                    className="text-sm text-foreground transition-colors hover:text-main"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>

      {/* Desktop: static */}
      <div className="hidden lg:block space-y-2">
        {titleHref ? (
          <Link href={titleHref} className="inline-block">
            <h2 className="text-lg font-medium transition-colors hover:text-main">
              {title}
            </h2>
          </Link>
        ) : (
          <h2 className="text-lg font-medium transition-colors hover:text-main">
            {title}
          </h2>
        )}
        <div className="flex flex-col space-y-1.5">
          {links.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              onClick={() => trackGeneric(`footer_link_${link.href.replace(/\//g, "").slice(0, 30)}`)}
              className="text-sm text-foreground transition-colors hover:text-main"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default FooterLinks;